import React from 'react';
export function ClosureNotice() {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return <main className="min-h-screen w-full flex justify-center bg-[#fdfbf7] p-8 md:p-16 print:p-0 print:bg-white" data-id="element-2">
      <div className="w-full max-w-[800px] bg-white shadow-sm border border-stone-200 p-12 md:p-20 print:shadow-none print:border-none print:p-0" data-id="element-3">
        {/* Document Header */}
        <header className="mb-16 text-center" data-id="element-4">
          <h1 className="text-4xl md:text-5xl mb-6 tracking-tight lowercase italic" data-id="element-5">
            nivie
          </h1>
          <div className="w-16 h-[1px] bg-stone-900 mx-auto mb-8" data-id="element-6"></div>
          <h2 className="text-xl uppercase tracking-widest font-normal mb-2" data-id="element-7">
            Notice of Permanent Cessation
          </h2>
          <p className="text-stone-500 italic" data-id="element-8">
            Document Ref: NV25338-LEGAL-2025-FINAL
          </p>
        </header>

        {/* Legal Content */}
        <article className="space-y-8 text-lg md:text-xl leading-relaxed text-stone-900 text-justify" data-id="element-9">
          <p data-id="element-10">
            <span className="font-bold uppercase mr-2" data-id="element-11">
              To Whom It May Concern:
            </span>
            NOTICE IS HEREBY GIVEN that the business entity operating under the
            trade name <span className="lowercase font-bold" data-id="element-12">nivie</span>{' '}
            (hereinafter referred to as the "Company") has permanently ceased
            all commercial operations, effective immediately.
          </p>

          <p data-id="element-13">
            Pursuant to the decision of the Board of Directors and in accordance
            with applicable corporate dissolution statutes, the Company has
            terminated all service offerings, product sales, and business
            activities. The legal entity associated with the brand is currently
            undergoing formal dissolution proceedings.
          </p>

          <div className="pl-8 border-l-2 border-stone-300 my-10 italic text-stone-700" data-id="element-14">
            "The Company shall no longer accept new engagements, process
            transactions, or maintain active client accounts. All existing
            contractual obligations have been terminated or settled in
            accordance with their respective terms."
          </div>

          <section data-id="element-15">
            <h3 className="uppercase text-sm tracking-widest font-bold mb-4 border-b border-stone-200 pb-2" data-id="element-16">
              1. Status of Operations
            </h3>
            <p className="mb-4" data-id="element-17">
              The website, digital assets, and physical premises associated with{' '}
              <span className="lowercase" data-id="element-18">nivie</span> are closed. No further
              updates, maintenance, or support will be provided for any legacy
              products or services.
            </p>
          </section>

          <section data-id="element-19">
            <h3 className="uppercase text-sm tracking-widest font-bold mb-4 border-b border-stone-200 pb-2" data-id="element-20">
              2. Creditor Claims & Inquiries
            </h3>
            <p className="mb-4" data-id="element-21">
              Any parties believing they have outstanding claims against the
              Company must submit formal written notice within thirty (30) days
              of this posting. Claims not received within the statutory period
              may be barred.
            </p>
            <p data-id="element-22">
              All legal inquiries, creditor claims, or official correspondence
              regarding the dissolution should be directed to the appointed
              legal representative at:
            </p>
            <div className="mt-6 bg-stone-50 p-6 border border-stone-100 text-center" data-id="element-23">
              <p className="uppercase text-sm tracking-widest mb-1" data-id="element-24">
                Legal Department
              </p>
              <p className="lowercase mb-1" data-id="element-25">legal@nivie.co</p>
              <p className="text-stone-500 text-base" data-id="element-26">
                Reference: Dissolution Proceedings
              </p>
            </div>
          </section>
        </article>

        {/* Footer */}
        <footer className="mt-24 pt-8 border-t border-stone-900 flex flex-col md:flex-row justify-between items-center text-stone-500 text-base" data-id="element-27">
          <div data-id="element-28">
            <p data-id="element-29">Executed on this day: August 30, 2025</p>
          </div>
          <div className="mt-4 md:mt-0" data-id="element-30">
            <p className="uppercase tracking-widest text-xs" data-id="element-31">
              Official Legal Notice
            </p>
          </div>
        </footer>

        <div className="mt-8 text-center" data-id="element-32">
          <p className="text-xs text-stone-400 uppercase tracking-[0.2em]" data-id="element-33">
            End of Document
          </p>
        </div>
      </div>
    </main>;
}